<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.1875 3.5C9.1875 4.70812 8.20812 5.6875 7 5.6875C5.79188 5.6875 4.8125 4.70812 4.8125 3.5C4.8125 2.29188 5.79188 1.3125 7 1.3125C8.20812 1.3125 9.1875 2.29188 9.1875 3.5Z"
      stroke="var(--icon-border-default)"
      stroke-width="1.1"
    />
    <path
      d="M7 7.4375C4.11492 7.4375 2.625 9.37388 2.625 12.25H11.375C11.375 9.29446 9.88508 7.4375 7 7.4375Z"
      stroke="var(--icon-border-default)"
      stroke-width="1.1"
    />
  </svg>
</template>
